import Vue from 'vue'
import ListaValoresApi from '@/api/workspace/onboarding/listavalores'

export default {  
    getCodigoUnicoNaLista(onboardingPais, arrayConstantes){
        let constante = null;
        if(onboardingPais != null && onboardingPais.pais != null){
            const codigoDuasLetrasPai = onboardingPais.pais.codigoDuasLetrasSuccessFactors;

            for(let cont = 0; cont < arrayConstantes.length; cont++){
                if(arrayConstantes[cont][codigoDuasLetrasPai] != undefined){
                    constante = arrayConstantes[cont][codigoDuasLetrasPai];
                    break;
                }
            }                
        }

        return constante;
    },   
    getParametrizacaoAtributo(onboardingPais, codigoUnicoAtributo){
        if(onboardingPais != null && onboardingPais != undefined && (onboardingPais.atributo || []).length > 0){
            const atributo = onboardingPais.atributo.filter(a => a.parametrizacaoOnboardingPaisAtributo.codigoUnico == codigoUnicoAtributo);

            if(atributo.length == 0) 
                return null;

            return atributo[0].parametrizacao.parametrizacaoOnboardingAtributo;
        }  

        return null;
    },          
    getValorAtributo(onboardingPais, codigoUnicoAtributo){
        if(onboardingPais != null && onboardingPais != undefined && (onboardingPais.atributo || []).length > 0){
            let index = Vue.prototype.$_.findIndex(onboardingPais.atributo, a => a.parametrizacaoOnboardingPaisAtributo.codigoUnico == codigoUnicoAtributo);
            if(index < 0) 
                return null;

            if(onboardingPais.atributo[index].parametrizacao.parametrizacaoOnboardingAtributo.listaValores == null){
                const valor = onboardingPais.atributo[index].valor;

                return {
                    index: index,
                    listaValores: false,
                    readonly: onboardingPais.atributo[index].readonly == undefined ? false : onboardingPais.atributo[index].readonly,
                    valor: (valor == undefined || Vue.prototype.$_.trim(valor) == "") ? null : Vue.prototype.$_.trim(valor)
                };
            }
            else if(onboardingPais.atributo[index].parametrizacao.parametrizacaoOnboardingAtributo.listaValores.indicadorMultiplaEscolha == true){
                return {
                    index: index,
                    listaValores: true,
                    readonly: onboardingPais.atributo[index].readonly == undefined ? false : onboardingPais.atributo[index].readonly,
                    valor: onboardingPais.atributo[index].valor
                };
            }
            else 
                return {
                    index: index,
                    listaValores: true,
                    readonly: onboardingPais.atributo[index].readonly == undefined ? false : onboardingPais.atributo[index].readonly,
                    valor: onboardingPais.atributo[index].listaValoresAtributo
                };
        } 
        
        return null;
    },
    getTraducaoListaValores(listaValores){
        const locale = localStorage.getItem("locale");
        if(listaValores == undefined || listaValores == null)
            return null;        

        let traducao = {
            nome: listaValores.nome,
            descricao: listaValores.descricao
        };

        if(listaValores.traducao == undefined || listaValores.traducao == null)
            return traducao;

        for(let count = 0; count < listaValores.traducao.length; count++){
            if(locale == listaValores.traducao[count].linguagem.codigoUnico){
                traducao.nome = listaValores.traducao[count].nome;
                traducao.descricao = listaValores.traducao[count].descricao;

                break;
            }
        }     
        
        return traducao;
    },  
    getTraducaoAtributoListaValores(atributo){
        const locale = localStorage.getItem("locale");
        if(atributo == undefined || atributo == null)
            return null; 

        let traducao = { descricao: atributo.descricao };
        if(atributo.traducao == undefined || atributo.traducao == null)
            return traducao;            

        for(let count = 0; count < atributo.traducao.length; count++){
            if(locale == atributo.traducao[count].linguagem.codigoUnico){
                traducao.descricao = atributo.traducao[count].descricao;
                break;
            }
        }     
        
        return traducao;
    },      
    async listaValores(id){
        let error = null;
        const listaValores = await ListaValoresApi.listarPorId(id).catch(erro => error = erro.error);                                      
        
        if(listaValores.success){
            let resultado = [];

            for(let cont = 0; cont < listaValores.data.atributo.length; cont++){
                const atributo = listaValores.data.atributo[cont];
                const traducaoAtributo = this.getTraducaoAtributoListaValores(atributo);

                if(traducaoAtributo != null){
                    atributo.descricao = traducaoAtributo.descricao;
                }

                resultado.push(atributo);
            }

            const traducao = this.getTraducaoListaValores(listaValores.data);   
            if(traducao != null){
                listaValores.data.nome = traducao.nome;
                listaValores.data.descricao = traducao.descricao;
            }                        
            
            listaValores.data.atributo = resultado;
            return listaValores.data;
        }   
        else{
            throw new Error(error[0]);    
        }
    }           
}